import { render, staticRenderFns } from "./RegisterResubmit.vue?vue&type=template&id=5b72ddc6&scoped=true&"
import script from "./RegisterResubmit.vue?vue&type=script&lang=ts&"
export * from "./RegisterResubmit.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterResubmit.vue?vue&type=style&index=0&id=5b72ddc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72ddc6",
  null
  
)

export default component.exports